import { BankError } from '#modules/Bank/Bank.types'

export interface ReopenConsumerSessionAction {
	type: typeof CONSUMER_SESSION_ACTIONS.REOPEN_SESSION
	payload: {
		sessionId?: string
	}
}

interface ReopenConsumerSessionSucceededAction {
	type: typeof CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_SUCCEEDED
}

interface ReopenConsumerSessionFailedAction {
	type: typeof CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_FAILED
	reopenSessionError: BankError
}

export const CONSUMER_SESSION_ACTIONS = {
	REOPEN_SESSION: 'CONSUMER_SESSION/REOPEN_SESSION',
	REOPEN_SESSION_FAILED: 'CONSUMER_SESSION/REOPEN_SESSION_FAILED',
	REOPEN_SESSION_SUCCEEDED: 'CONSUMER_SESSION/REOPEN_SESSION_SUCCEEDED',
} as const

export type ConsumerSessionDataAction =
	| ReopenConsumerSessionAction
	| ReopenConsumerSessionFailedAction
	| ReopenConsumerSessionSucceededAction

export const reopenConsumerSession = (
	sessionId?: string,
): ReopenConsumerSessionAction => {
	return {
		type: CONSUMER_SESSION_ACTIONS.REOPEN_SESSION,
		payload: {
			sessionId,
		},
	}
}

export const reopenConsumerSessionSucceeded =
	(): ReopenConsumerSessionSucceededAction => {
		return {
			type: CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_SUCCEEDED,
		}
	}

export const reopenConsumerSessionFailed = (
	reopenSessionError: BankError,
): ReopenConsumerSessionFailedAction => {
	return {
		type: CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_FAILED,
		reopenSessionError,
	}
}
